import C from "@/components/Toolbar.module.css";

import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";

export function ToolbarText({ children, icon, className }: { children: ReactNode; icon?: string; className?: string }) {
    return (
        <div className={cn(C.Text, className)}>
            {!!icon && <MaskIcon className={`${icon} mr-1`} />}
            {children}
        </div>
    );
}
